import { render, staticRenderFns } from "./GlobalSearchResultsDropdown.vue?vue&type=template&id=373bdee4"
import script from "./GlobalSearchResultsDropdown.vue?vue&type=script&lang=js"
export * from "./GlobalSearchResultsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('373bdee4')) {
      api.createRecord('373bdee4', component.options)
    } else {
      api.reload('373bdee4', component.options)
    }
    module.hot.accept("./GlobalSearchResultsDropdown.vue?vue&type=template&id=373bdee4", function () {
      api.rerender('373bdee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/globalSearch/GlobalSearchResultsDropdown.vue"
export default component.exports